<template>
  <div :class="$style.contact">
    <div v-for="(el, dataIndex) in data" :key="dataIndex" :class="$style.part">
      <h2>{{ el.title }}</h2>
      <ul>
        <li v-for="(item, contentIndex) in el.content" :key="contentIndex">
          <label>{{ item.title }}：</label>
          <span>{{ item.desc }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['contact']),
    data() {
      return [
        {
          title: '厦门总部',
          content: [
            {
              title: '地址',
              desc: '福建省厦门市思明区软件园二期观日路26号204室',
            },
            { title: '邮编', desc: '361008' },
            // { title: '游戏客服专线', desc: this.contact.phone_cs },
            { title: '电话', desc: this.contact.phone },
            { title: '传真', desc: '0592-3181364' },
          ],
        },
        {
          title: '成都分公司',
          content: [
            {
              title: '地址',
              desc: '四川省成都市高新区益州大道北段777号中航国际交流中心A座16F',
            },
            { title: '邮编', desc: '610041' },
            { title: '电话', desc: '028-85286217' },
            { title: '传真', desc: '028-85286217-800' },
          ],
        },
      ]
    },
  },
}
</script>

<style lang="less" module>
@illus-width: 2.88rem;
@illus-height: 2.16rem;

.contact {
  display: flex;
  justify-content: center;
  padding: @padding-base 3.6rem 2.35rem;
  background: #fbfbfb url('./images/contact-bg.png') no-repeat center bottom;
  background-size: 19.2rem 6.76rem;
}

.part {
  @padding-top: 0.7rem;
  @padding-left: 1.2rem;
  @border-width: 0.01rem;

  position: relative;
  width: 50%;
  padding: @padding-top @padding-left;
  border: @border-width solid #b5b5b5;
  background-color: #fff;
  box-sizing: border-box;

  &::before {
    .size(@illus-width,@illus-height);
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    background: url('./images/contact-badge.png') no-repeat 0 100%;
    background-size: 200% 200%;
  }

  h2 {
    font-weight: 700;
    font-size: 0.18rem;

    @media screen and (max-width: @laptop-width) {
      font-size: 16px;
    }
  }

  ul {
    position: relative;
    margin-top: 0.5rem;
  }

  li {
    display: flex;
    margin-bottom: 0.3rem;
    line-height: 1.5;

    label {
      white-space: nowrap;
    }

    span {
      flex: 1;
      display: block;
    }
  }

  &:first-child {
    margin-right: -@border-width;

    &::before {
      background-position: 0 0;
    }

    &:hover {
      &::before {
        background-position: 100% 0;
      }
    }
  }

  &:hover {
    z-index: 1;
    border-color: #fff;
    border-top-width: @border-width;
    border-top-color: @primary;
    box-shadow: 0.06rem 0.06rem 0.22rem fade(#000, 20%);

    &::before {
      background-position: 100% 100%;
    }

    &::after {
      .size(100%, 0.02rem);
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      background-color: @primary;
    }
  }
}

@media screen and (max-width: @laptop-width) {
  .contact {
    padding-left: 3rem;
    padding-right: 3rem;
  }
}

@media screen and (max-width: @mini-width) {
  .contact {
    display: block;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .part {
    width: 100%;

    &:first-child {
      margin-bottom: 0.5rem;
    }

    &::before {
      .size(@illus-width * 2, @illus-height * 2);
    }
  }
}
</style>
